module.exports = __webpack_public_path__ + "img/circle-tick.3c33cc06.svg";